import React from "react";
import { PencilSquareIcon,DocumentArrowUpIcon} from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

const CustomTitleAccount = ({ onClick, onExit, title, icon, isEditing ,addresses}) => {
  const { t } = useTranslation();
  
  return (
    <div className="flex items-center justify-between md:mt-4">
      <div className="flex items-center">
        {icon && <span className="pointer-events-none">{icon}</span>}
        <h2 className="text-base font-semibold text-black md:text-2xl lg:text-3xl">
          {title}
        </h2>
      </div>
        <div className="flex gap-3 my-3">


        <button
          onClick={onClick}
          className={`flex items-center gap-2 px-2 py-2 text-sm font-medium rounded-lg duration-300 ${
            isEditing ? "text-black bg-custom-yellow " : "text-black bg-transparent cursor-text"
          }`}
        >
          <span className="text-black">{isEditing ? t("Save") : t("edit")}</span>
          {isEditing ? (
            <DocumentArrowUpIcon  className="w-4 h-4 text-black " />
          ) : (
            <PencilSquareIcon className="w-4 h-4 text-black " />
          )}
        </button>
        </div>

    </div>
  );
};

export default CustomTitleAccount;
  